// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateChileanStreetNumber(streetNumber: string): ?UserInputValidationError {
  return streetNumber && streetNumber.trim() && parseInt(streetNumber, 10) ? VALID : { id: 'empty'};
}
